import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Collapse } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import globalColors from "../styles/globalColors";

type Props =
  | {
      expanding: true;
      onToggle: (section: string) => void;
      open: boolean;
      title: string;
      titleExtra?: React.ReactNode;
      containerStyles?: any;
      contentStyles?: any;
    }
  | {
      expanding?: false | null;
      title?: string;
      titleExtra?: React.ReactNode;
      containerStyles?: any;
      contentStyles?: any;
    };

const DetailContentSection: React.FC<Props> = props => {
  const { children, containerStyles, contentStyles } = props;

  return props.expanding ? (
    <div
      css={[
        styles.collapseContainer,
        {
          ".ant-collapse-item": {
            ...styles.contentSectionContainer,
            ...containerStyles,
            ".ant-collapse-header": styles.contentSectionHeader
          }
        }
      ]}
    >
      <Collapse
        bordered={false}
        activeKey={[props.open ? props.title : ""]}
        expandIconPosition="right"
        onChange={() => props.onToggle(props.title)}
        expandIcon={({ isActive }) => (
          <FontAwesomeIcon
            icon={faChevronDown}
            transform={{ rotate: isActive ? 180 : 0 }}
            style={styles.icon}
          />
        )}
      >
        <Collapse.Panel
          header={
            <span css={styles.header}>
              {props.title}
              {props.titleExtra}
            </span>
          }
          key={props.title}
          css={styles.panel}
        >
          <div css={[styles.content, contentStyles]}>{props.children}</div>
        </Collapse.Panel>
      </Collapse>
    </div>
  ) : (
    <div
      css={[
        styles.noExpandContent,
        { backgroundColor: globalColors.lightGray }
      ]}
    >
      <div css={[styles.header, styles.headerNoExpand]}>
        <span>
          {props.title}
          {props.titleExtra}
        </span>
      </div>
      <div
        css={[styles.content, { marginLeft: 0, marginRight: 0 }, contentStyles]}
      >
        {children}
      </div>
    </div>
  );
};

const styles = {
  collapseContainer: {
    ".ant-collapse-item": {
      borderBottom: "1px solid #eee !important"
    }
  },
  content: {
    backgroundColor: globalColors.white,
    borderRadius: 5,
    margin: "0 0 0",
    marginLeft: 40,
    marginRight: 40,
    padding: 20
  },
  header: {
    fontSize: 24,
    fontWeight: 600,
    color: globalColors.textSecondary,
    lineHeight: "50px",
    display: "block"
  },
  headerNoExpand: {
    marginBottom: 12
  },
  icon: {
    fontSize: 20,
    color: globalColors.textSecondary,
    marginRight: 15
  },
  noExpandContent: {
    backgroundColor: "white",
    padding: "12px 24px 24px",
    borderRadius: 10,
    border: "1px solid #eee",
    marginBottom: 30
  },
  panel: {
    borderRadius: "10px !important",
    marginBottom: 24,
    padding: 0,
    border: "1px solid #eee",
    overflow: "hidden",
    ".ant-collapse-content-box": {
      padding: 0
    }
  },
  contentSectionContainer: {
    backgroundColor: globalColors.lightGray,
    paddingBottom: 40
  },
  contentSectionHeader: {
    marginLeft: 23,
    marginRight: 13
  }
};

export default DetailContentSection;
